/** @app — application layer; owned per-fork (LMS / OTT). See PLATFORM_FILES.md. */

interface OutcomesListProps {
  outcomes: string[];
  /** Use 'hero' for the larger-typography variant in Decision-first
   *  where outcomes are the page's primary argument. */
  size?: 'normal' | 'hero';
}

export function OutcomesList({ outcomes, size = 'normal' }: OutcomesListProps) {
  if (outcomes.length === 0) return null;
  return (
    <ul className={size === 'hero' ? 'cd-outcomes cd-outcomes-hero' : 'cd-outcomes'}>
      {outcomes.map((o, i) => (
        <li key={i} className="cd-outcome">
          <span className="cd-outcome-check" aria-hidden>
            ✓
          </span>
          <span>{o}</span>
        </li>
      ))}
    </ul>
  );
}
